import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { getStripe } from '../../services/PaymentServiceAnnuaire';

interface StripeWrapperProps {
  children: React.ReactNode;
}

const StripeWrapper: React.FC<StripeWrapperProps> = ({ children }) => {
  const stripePromise = getStripe();

  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeWrapper;